import React, { useCallback, useContext, useEffect, useState } from 'react';
import { BasicScrollView } from "@/components/BasicScrollView";
import { ScrollView, StyleSheet, View } from 'react-native';
import { RelativePathString, useRouter } from 'expo-router';
import Head from 'expo-router/head';
import * as AppUtils from '@/utilities/AppUtils';
import { CustomText } from '@/components/CustomText';
import { Button, Fieldset, Panel, Radio, Text } from 'react95-native-rabbl';
import { CustomDivider } from "@/components/CustomDivider";
import * as AppConstants from '@/utilities/AppConstants';
import { AppContext } from '@/components/AppContext';
import * as AppUtilities from "@/utilities/AppUtilities";
import Footer from '@/components/Footer';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { setLoggedIn } from '@/state/user';
import { CommunityMembership } from "@/types/community_membership";
import * as AppConsts from '@/utilities/AppConsts';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    alignItems: 'center',
    backgroundColor: 'transparent',
    gap: 20,
  },
  contentWrapper: {
    padding: 20,
    gap: 20,
  },
});

export default function Join() {
  const loggedIn = useSelector((state: RootState) => state.user.loggedIn);
  const community = useSelector((state: RootState) => state.user.current_community);
  const [profile, setProfile] = useState<string>('');
  const { showSpinner, hideSpinner } = useContext(AppContext);
  const router = useRouter();
  const [processing, setProcessing] = useState(false);
  const dispatch = useDispatch();

  const onSubmit = useCallback(async () => {
    try {
      setProcessing(true);
      showSpinner();

      throw new Error("Not implemented");

    } catch (e) {
      AppUtils.showErrorToast(AppUtilities.getErrors(e), () => onSubmit(), true);
      AppUtilities.handleException(e, "Join.onSubmit");
    } finally {
      setProcessing(false);
      hideSpinner();
    }
  }, [loggedIn]);

  return (
    <BasicScrollView center={true}>
      <Meta title={"Join"} />
      <Panel variant='raised' elevation={4}>
        <View style={AppConstants.STYLES.padding20gap10center}>
          <CustomText>Join {community.name}</CustomText>
          <View style={AppConstants.STYLES.padding2} />
          <CustomDivider fullWidth={true} />
          <View style={AppConstants.STYLES.padding2} />
          <Fieldset label='Profile' style={AppConstants.STYLES.gap20}>
            {/*<Radio
              status={profile == 'man' ? 'checked' : 'unchecked'}
              onPress={() => setProfile('man')}
              label='Man'
            />*/}
            <Radio
              status={'unchecked'}
              label='Create new profile (coming soon)'
              disabled={true}
            />
          </Fieldset>
          <Button
            onPress={onSubmit}
            disabled={profile == ''}
          >Next</Button>
        </View>
      </Panel>
      <Footer />
    </BasicScrollView>
  );
}
